import { Expose } from 'class-transformer';
import { ShipmentReceiverFleetResponseStatus } from '@shared-features/enums/shipment-receiver-fleet-response-status enum';
import { Model } from '@shared-features/models/model';

export class shipmentReceiverFleetsList extends Model {
  @Expose() id: number;
  @Expose() fleetId: number;
  @Expose() fleetName: string;
  @Expose() responseStatus: ShipmentReceiverFleetResponseStatus;
  @Expose() rejectionReason: string;
  @Expose() createdAt?: number;
  @Expose() updatedAt?: number;

  constructor() {
    super();
  }
}
